import { useState } from 'react';

export const useChartFilters = () => {
  // Simplified filter structure - only backend filters
  const initialFilterState = {
    siteids: [],
    vehiclemodels: [],
    vehicletypes: []
  };

  const [chartFilters, setChartFilters] = useState(initialFilterState);

  // Handle filter changes
  const handleFilterChange = (filterKey, value) => {
    setChartFilters(prev => ({
      ...prev,
      [filterKey]: value
    }));
  };

  // Reset all filters to initial state
  const handleResetFilters = () => {
    setChartFilters(initialFilterState);
  };

  return {
    chartFilters,
    handleFilterChange,
    handleResetFilters,
  };
};
